import request from '@/utils/request'

const url = '/home/serviceinfo/'
const api = {
  ChatUpload (data) {
    return request({
      url: '/admin/Upload/ChatUpload',
      method: 'post',
      data
    })
  },
  getUserlist (data) {
    return request({
      url: url + 'getUserlist',
      method: 'post',
      data
    })
  },
  getChatlist (data) {
    return request({
      url: url + 'getChatlist',
      method: 'post',
      data
    })
  },
  getChattourlist (data) {
    return request({
      url: url + 'getChattourlist',
      method: 'post',
      data
    })
  },
  updateNickname (data) {
    return request({
      url: url + 'updateNickname',
      method: 'post',
      data
    })
  },
  getUserInfo (data) {
    return request({
      url: url + 'getUserInfo',
      method: 'post',
      data
    })
  },
  getCustomerService (data) {
    return request({
      url: url + 'getCustomerService',
      method: 'post',
      data
    })
  },
  confirmService (data) {
    return request({
      url: url + 'confirmService',
      method: 'post',
      data
    })
  },
  SearchSelect (data) {
    return request({
      url: '/home/Search/SearchSelect',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/service.js